import { useMutation } from '@apollo/client';
import { UpdateToolRoomInput } from '@bechtel/ht-types';
import { UPDATE_TOOL_ROOM } from '~/gql/tool-room';
import { ToolRoomInputData, ToolRoomPayloadData } from '~/views/project-admin/types';

export const useUpdateToolRoom = () => {
  const [updateToolRoomData, { data, loading, error }] = useMutation<ToolRoomPayloadData, ToolRoomInputData>(
    UPDATE_TOOL_ROOM
  );
  const updateToolRoom = (
    input: UpdateToolRoomInput,
    onCompleted?: (data: ToolRoomPayloadData) => void,
    onError?: (error) => void
  ) => {
    updateToolRoomData({
      variables: {
        updateToolRoomInput: input,
      },
      onCompleted: (data) => {
        onCompleted && onCompleted(data);
      },
      onError: (error) => {
        onError && onError(error);
      },
      refetchQueries: ['SearchUserToolRooms'],
    });
  };

  return { updateToolRoom, data, loading, error };
};
